import React from 'react';
import { useSelector } from 'react-redux';

import CommonLoader from '../../../../../../../components/common-loader/CommonLoader';

import scss from './VariationLoader.module.scss';

function VariationLoader() {
  const isVariationLoading = useSelector((state) => state.scout.isVariationLoading);

  if (!isVariationLoading) {
    return null;
  }

  return (
    <div className={scss.overlay}>
      <CommonLoader isLoading={isVariationLoading} />
    </div>
  );
}

export default VariationLoader;
